import main from './main.vue'
import api from './main.js'

export default (Vue) => {
  Vue.component(main.name, main)
  Vue.prototype.$toast = api
  Vue.toast = api
}
